import React, { useState, useEffect } from 'react'
import { NavLink, useNavigate } from 'react-router-dom';
import { Row, Col, Container, Input, Table } from 'reactstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


//assets
import { directUrl, homePageUrl } from "../../../helpers/Constants";
import { requestApi } from "../../../request-api";
import DataTable from "react-data-table-component";
import { API_URL } from '../../../config';
import axios from 'axios';
import { userStore } from '../../../stores';
import { dataToXLS } from '../../../helpers/dataToXLS';

function Branch() {
  const navigate = useNavigate()
  let [checked, setChecked] = useState(false);
  let [isChecked, setIsChecked] = useState(false);
  const [report, setReport] = useState([]);
  const [searchClients, setSearchClients] = useState('');
  const [search, setSearch] = useState('');
  const [searchStatus, setSearchStatus] = useState('');
  let [companyFilter, setCompanyFilter] = useState([]);
  let [branchFilter, setBranchFilter] = useState([]);
  let [reportFilter, setReportFilter] = useState([]);
  let [downloadData, setDownloadData] = useState([]);
  const [filteredSearch, setFilteredSearch] = useState([]);
  const [companyName, setCompanyName] = useState([]);
  const [branchId, setBranchId] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleOnChange = () => {
    setIsChecked(!isChecked);
  };



  const downloadReport = (reportId) => {
    
       dataToXLS(downloadData, 'Branch');

   
  }

  const [startDate, setStartDate] = useState(new Date());
  const routeChangeToCreateBranch = () => {
    navigate(`${directUrl}auditor/create-branch`);
  };
  const [columns, setColumns] = useState([
    {
      name: "Sr.No.",
      selector: (row) => (
        <td>
          {row.srno}
        </td>
      ),
      sortable: true,
    },
    {
      name: "Company Name",
      selector: (row) => <td>{row.company_name
      } &nbsp; </td>,
      sortable: true,
    },
    {
      name: "Report ID",
      selector: (row) => 
     
        row.report_id.map((report,index)=>( <td className="arrowBox arrow-left">
          <NavLink 
          // onClick={() => downloadReport(row.report_id)}
          onClick={(e) => {
            console.log("row data",row)
            e.preventDefault();
            navigate(
              `${directUrl}auditor/legislation-list/${row.id[index]}`,
              {
                state: { row: row },
              }
            );
          }}
          >{report}</NavLink>
        </td>)),
      
      
      
    
      sortable: true,
    },
    {
      name: "Branch_ID",
      selector: (row) => row.branch_id,
      sortable: true,
    },
    {
      name: "Branch POC Name",
      selector: (row) => row.branch_poc_name,
      sortable: true,
    },

    {
      name: "Date Of Joining",
      selector: (row) => row.date_of_joining,
      sortable: true,
    },
    {
      name: "POC Number",
      selector: (row) => row.poc_number,
      sortable: true,
    },
    {
      name: "Assign Compliance Officer",
      selector: (row) => row.compliance_officer_name,
      sortable: true,
    },
    {
      name: "Office Address",
      selector: (row) => row.office_address,
      sortable: true,
    },



  ]);

  const getData = () => {
    setLoading(true)
    requestApi('/auditor/branch/getBranchWithReport', {
      method: 'get'
    }).then((data) => {
      console.log("AyanPoonawala", data)
      setReport(data.data)
      setFilteredSearch(data.data);
      let compN = [];
      let compId = [];
      let compDate = [];
      
      setCompanyName(
        data.data.map((cn) => {
          return cn.company_name;
        })
      );
      data.data.map((c) => {
        if (!compN.find((cn) => cn === c.company_name)) {
          compN.push(c.company_name);
        }
        if (!compId.find((cn) => cn === c.branch_id)) {
          compId.push(c.branch_id);
        }
        if (!compDate.find((cn) => cn === c.date_of_mou)) {
          compDate.push(c.date_of_mou);
        }
        setLoading(false)
        setCompanyName(compN);
        setBranchId(compId);
      });
    }).catch(error=>{
      setLoading(false)
      console.log(error)
    })
  }

  useEffect(() => {
    if (search == 'empty') {
      return setFilteredSearch(report);
    }
    const result = report.filter((c) => {
      return (
        c.company_name.toLowerCase().match(search.toLowerCase()) ||
        c.branch_id.toLowerCase().match(search.toLowerCase()) ||
        c.poc_number.toLowerCase().match(search.toLowerCase()) ||
        c.office_address.toLowerCase().match(search.toLowerCase())
      );
    });
    setFilteredSearch(result);
  }, [search]);

  useEffect(() => {
    const result = report.filter((comp) => {
      let created_date = new Date(Date.parse(comp.date_of_joining));
      let filterDate = new Date(Date.parse(startDate));
      // created_date =  created_date.getDate()
      // filterDate = filterDate.getDate();
      console.log(
        '0',
        created_date.getDate() == filterDate.getDate() &&
          created_date.getMonth() == filterDate.getMonth() &&
          created_date.getFullYear() == filterDate.getFullYear()
      );
      return (
        created_date.getDate() == filterDate.getDate() &&
        created_date.getMonth() == filterDate.getMonth() &&
        created_date.getFullYear() == filterDate.getFullYear()
      );
    });
    setFilteredSearch(result);
  }, [startDate]);

  const dummy = (e) => {
    console.log("-->",e)
   if (e.allSelected == true) {    
    let rows=[];
    console.log("e.allSelected == true",e.selectedRows)
    for(let i=0;i<e.selectedRows.length;i++)
    {
      
      if(e.selectedRows[i].report_id.length > 0)
      {
        let report_id='';
        for(let j=0;j<e.selectedRows[i].report_id.length;j++)
        {
          if( j == e.selectedRows[i].report_id.length-1)
          {
            report_id = report_id + e.selectedRows[i].report_id[j] 
          }
          else{
            report_id = report_id + e.selectedRows[i].report_id[j] + ","
          }    
        }
        e.selectedRows[i].report_id = report_id
      }
    }
     setDownloadData(e.selectedRows);
   } else if (e.allSelected == false && e.selectedCount == 0) {
     setDownloadData([]);
   } else if (e.selectedCount > 0) {
    let rows=[];
    
    for(let i=0;i<e.selectedRows.length;i++)
    {
      if(e.selectedRows[i].report_id.length > 0)
      {
        let report_id='';
        console.log("e.selectedCount > 0",e.selectedRows[i])
        for(let j=0;j<e.selectedRows[i].report_id.length;j++)
        {
          if( j == e.selectedRows[i].report_id.length-1)
          {
            report_id = report_id + e.selectedRows[i].report_id[j] 
          }
          else{
            report_id = report_id + e.selectedRows[i].report_id[j] + ","
          } 
        }
        e.selectedRows[i].report_id = report_id
      }
    }
     setDownloadData(e.selectedRows);
   } else if (e.selectedCount == 0) {
     setDownloadData([]);
   }

    if (e.selectedCount == 0) {
      setIsChecked(false);
    }
    else {
      setIsChecked(true);
    }
  }


  useEffect(() => {

    getData()

  }, [])

  return (
    <section className="lyt-section p-0">
      {loading ? (
        <div className="loader-container">
          <div className="spinner"></div>
        </div>
      ) : null}
      <Container fluid className="typ-container">
        <div className="bs-card">
          <Row>
            {isChecked ? (
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="bs-action-btn">
                  <div className="button-group">
                    <a
                      className="action-btn"
                      onClick={(e) => {
                        downloadReport();
                      }}
                    >
                      {' '}
                      <span class="icon icon-download"></span>
                    </a>
                    {/* <a className="action-btn" href="">
                      {' '}
                      <span class="icon icon-share"></span>
                    </a>
                    <a className="action-btn" href="">
                      <span class="icon icon-delete"></span>
                    </a> */}
                  </div>
                </div>
              </Col>
            ) : (
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="bs-table ">
                  <div className="main-header">
                    <form className="bs-form">
                      <div className="search-btn">
                        <Input
                          type="text"
                          placeholder="Search..."
                          onChange={(e) => setSearch(e.target.value)}
                        />
                        <i className="icon icon-search"></i>
                      </div>
                      <div className="dropdown-bx">
                        <label className="form-label">Company Name : </label>
                        <Input
                          type="select"
                          name="select"
                          onChange={(e) => setSearch(e.target.value)}
                          id="exampleSelect"
                        >
                          <option value={'empty'}>Select</option>
                          {companyName.map((company) => (
                            <option key={company} value={company}>
                              {company}
                            </option>
                          ))}
                        </Input>
                      </div>
                      <div className="dropdown-bx">
                        <label className="form-label">Branch ID : </label>
                        <Input
                          type="select"
                          onChange={(e) => setSearch(e.target.value)}
                          name="select"
                          id="exampleSelect"
                        >
                          <option value={'empty'}>Select All</option>
                          {branchId.map((company) => (
                            <option key={company} value={company}>
                              {company}
                            </option>
                          ))}
                        </Input>
                      </div>
                      <div className="dropdown-bx report-date">
                        <label className="form-label">Date : </label>
                        {/* <Input type="text" name="text" id="exampleEmail" className='cstm-input' placeholder="Enter Branch ID" /> */}
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          placeholderText="date"
                          className="typ-date"
                        />
                      </div>
                    </form>
                    <div className="left-button">
                      <button
                        className="bs-btn btn-submit typ-create"
                        onClick={routeChangeToCreateBranch}
                      >
                        <span class="icon icon-plus"></span> Create branch
                      </button>
                    </div>
                  </div>
                </div>
              </Col>
            )}
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="bs-table typ-datable overflow-on border">
                <DataTable
                  columns={columns}
                  data={filteredSearch}
                  pagination
                  fixedHeader
                  fixedHeaderScrollHeight="450px"
                  selectableRows
                  onSelectedRowsChange={dummy}
                  selectableRowsHighlight
                  highlightOnHover
                />
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Branch

